import React from "react";
import KlydosPickDialog from "./KlydosPickDialog";

type PublicKlydosPickDialogProps = {
  onClose: () => void;
  selectedKlydos: string[];
  onPickKlydos: (selectedKlydos: string[]) => void;
  limit?: number;
};

const PublicKlydosPickDialog: React.FC<PublicKlydosPickDialogProps> = (
  props,
) => <KlydosPickDialog {...props} publicOnly />;

export default PublicKlydosPickDialog;
